export const FIELD_TYPE_INPUT = 'input';
export const FIELD_TYPE_TEXTAREA = 'textarea';
export const FIELD_TYPE_SELECT = 'select';
export const FIELD_TYPE_MULTIPLE_SELECT = 'multipleSelect';
export const FIELD_TYPE_CASCADER = 'cascader';
export const FIELD_TYPE_CHECKBOX = 'checkbox';
export const FIELD_TYPE_CHECKBOX_GROUP = 'checkboxgroup';
export const FIELD_TYPE_RADIO = 'radio';
export const FIELD_TYPE_RADIO_GROUP = 'radiogroup';
export const FIELD_TYPE_DATE = 'date';
export const FIELD_TYPE_YEAR = 'year';
export const FIELD_TYPE_MONTH = 'month';
export const FIELD_TYPE_DATETIME = 'datetime';
export const FIELD_TYPE_DATERANGE = 'daterange';
export const FIELD_TYPE_DATETIME_RANGE = 'datetimerange';
export const FIELD_TYPE_TIME = 'time';
export const FIELD_TYPE_TIME_RANGE = 'timerange';
export const FIELD_TYPE_POP_ONE = 'POP_ONE';
export const FIELD_TYPE_POP_MULTI = 'POP_MULTI';
export const FIELD_TYPE_TREE_POP_ONE = 'TREE_POP_ONE';
export const FIELD_TYPE_TREE_POP_MULTI = 'TREE_POP_MULTI';
export const FIELD_TYPE_LIST_POP_ONE = 'LIST_POP_ONE';
export const FIELD_TYPE_LIST_POP_MULTI = 'LIST_POP_MULTI';
export const FIELD_TYPE_FILE = 'FILE';
export const FIELD_TYPE_RICH_TEXT = 'RICH_TEXT';
export const FIELD_TYPE_INPUT_NUMBER = 'input-number';
export const FIELD_TYPE_NATIVE_INPUT_NUMBER = 'number';
export const FIELD_TYPE_EMPTY = 'empty';
export const FIELD_TYPE_TITLE = 'title';
export const FIELD_TYPE_SWITCH = 'switch';
/**
 * 上传组件直接显示在x-condition的行里面
 * @type {string}
 */
export const DISPLAY_MODE_INLINE = 'inline';
export const DISPLAY_MODE_DIALOG = 'dialog';

/**
 * 上传文件类型
 * @type {{label: string, value: string}[]}
 */
export const UPLOAD_FILE_TYPES = [
  {label: 'jpg', value: 'jpg'},
  {label: 'jpeg', value: 'jpeg'},
  {label: 'png', value: 'png'},
  {label: 'bmp', value: 'bmp'},
  {label: 'gif', value: 'gif'},
  {label: 'pdf', value: 'pdf'},
  {label: 'doc', value: 'doc'},
  {label: 'docx', value: 'docx'},
  {label: 'xls', value: 'xls'},
  {label: 'xlsx', value: 'xlsx'},
  {label: 'ppt', value: 'ppt'},
  {label: 'pptx', value: 'pptx'},
  {label: 'txt', value: 'txt'}
];

/**
 * 可选择文件，图片
 * @type {string}
 */
export const ACCEPT_IMAGE = '.jpg,.JPG,.jpeg,.JPEG,.png,.PNG';
